import { Flex } from 'src/components/layout';
import { MoreOptionsMenu, Option } from 'src/components/molecules';
import { MymeCategory } from './Category';

interface Props {
  category?: string;
  options?: Option[];
}

export const MymePreviewHeader = ({ category, options }: Props) => {
  return (
    <Flex justifyContent='space-between' position='relative' zIndex={10} gridArea='header'>
      <div>{category && <MymeCategory category={category} />}</div>
      {options && <MoreOptionsMenu options={options} sx={{ mr: -1 }} />}
    </Flex>
  );
};
